(function () {
  if (window.__mtInit) { window.__mtInitAll && window.__mtInitAll(); return; }
  window.__mtInit = true;

  function once(el, fn) {
    if (!el || el.dataset.mtInit) return;
    el.dataset.mtInit = '1';
    fn(el);
  }

  function initReveals() {
    var els = document.querySelectorAll('.mt-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) {
      if (el.dataset.mtRevealObs) return;
      el.dataset.mtRevealObs = '1';
      io.observe(el);
    });
  }

  function initHeroSpotlight() {
    document.querySelectorAll('[data-mt-hero]').forEach(function (hero) {
      once(hero, function (el) {
        if (window.matchMedia('(pointer: coarse)').matches) return;
        el.addEventListener('mousemove', function (e) {
          var rect = el.getBoundingClientRect();
          var x = ((e.clientX - rect.left) / rect.width) * 100;
          var y = ((e.clientY - rect.top) / rect.height) * 100;
          el.style.setProperty('--mt-mx', x + '%');
          el.style.setProperty('--mt-my', y + '%');
        });
      });
    });
  }

  function initAcordeon() {
    document.querySelectorAll('[data-mt-acordeon]').forEach(function (wrap) {
      once(wrap, function (el) {
        var items = el.querySelectorAll('.mt-acordeon-item');
        var visuals = el.parentElement.querySelectorAll('.mt-beneficios-visual img');
        items.forEach(function (item, idx) {
          var btn = item.querySelector('.mt-acordeon-btn');
          btn.addEventListener('click', function () {
            items.forEach(function (i) { i.classList.remove('is-open'); });
            item.classList.add('is-open');
            visuals.forEach(function (img, vIdx) {
              img.classList.toggle('is-active', vIdx === idx);
            });
          });
        });
      });
    });
  }

  function initMacroZoom() {
    document.querySelectorAll('.mt-macro-media').forEach(function (media) {
      once(media, function (el) {
        if (!('IntersectionObserver' in window)) { el.classList.add('mt-visible'); return; }
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) { el.classList.add('mt-visible'); io.unobserve(el); }
          });
        }, { threshold: 0.35 });
        io.observe(el);
      });
    });
  }

  function initEscenarios() {
    document.querySelectorAll('[data-mt-escenarios]').forEach(function (wrap) {
      once(wrap, function (el) {
        var tabs = el.querySelectorAll('.mt-escenario-tab');
        var panels = el.querySelectorAll('.mt-escenario-panel');
        tabs.forEach(function (tab, idx) {
          tab.addEventListener('click', function () {
            tabs.forEach(function (t) { t.classList.remove('is-active'); });
            panels.forEach(function (p) { p.classList.remove('is-active'); });
            tab.classList.add('is-active');
            panels[idx].classList.add('is-active');
          });
        });
      });
    });
  }

  function initColores() {
    document.querySelectorAll('[data-mt-colores]').forEach(function (wrap) {
      once(wrap, function (el) {
        var swatches = el.querySelectorAll('.mt-swatch');
        var visuals = el.querySelectorAll('.mt-colores-visual img');
        var nombreEl = el.querySelector('.mt-color-nombre');
        swatches.forEach(function (sw, idx) {
          sw.addEventListener('click', function () {
            swatches.forEach(function (s) { s.classList.remove('is-active'); });
            sw.classList.add('is-active');
            visuals.forEach(function (img, vIdx) { img.classList.toggle('is-active', vIdx === idx); });
            if (nombreEl) nombreEl.textContent = sw.getAttribute('data-nombre') || '';
          });
        });
      });
    });
  }

  function initAll() {
    initReveals();
    initHeroSpotlight();
    initAcordeon();
    initMacroZoom();
    initEscenarios();
    initColores();
  }

  window.__mtInitAll = initAll;
  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
